/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useSmsNotificationStore = defineStore("smsnotification", {
  actions: {
    async resend(uid) {
      return new Promise((resolve, reject) => {
        try {
          const response = http.post(`/noti-svc/duetx/resend/${uid}`);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async listFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
          refNumber: payload.refNumber,
          cusUid: payload.cusUid,
          "notifyDate:ge": payload.notifyDateGe,
          "notifyDate:le": payload.notifyDateLe,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const response = http.post("/noti-svc/duetx/list", body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
